import template        from "./label-batchage.html";
import css             from "./label-batchage.css";

import moment		   from "moment";
import {Label}   	   from "gui";


class BatchAgeLabel extends Label {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-label-batchage", BatchAgeLabel);
  }
  static get schema() {
    return({
      "description": "User defined label that show the batch age",
      "type": "object",
      "properties": {}
    });
  }
  static get designer() {
    return({
      "category": "User Defined",
      "icon": {"context": "actions", "size": 16, "iconname": "insert-button"}
    });
  }
  constructor(...args) {
    super(...args);
            
    document.addEventListener("onupdatefermentations", this.onupdatefermentations_handler.bind(this));
  }
  onupdatefermentations_handler(event) {
    var fermentations = event.detail;

    this.removeAttribute("inoculated");
    this.value = "";
    if (this.__interval) {
      clearInterval(this.__interval);
      delete this.__interval;
    }

    for (const fermentation of fermentations) {  
      if (fermentation.running && fermentation.inoculationDate) {
        this.setAttribute("inoculated", "");      
        this.__interval = setInterval(this.__interval_handle.bind(this), 5000);
        this.__id = fermentation.id;
        this.__inoculationDate = fermentation.inoculationDate;
        this.__interval_handle();
      }
    }
  }
  __interval_handle() {    
    var hours = Math.round(moment.duration(moment(new Date()).diff(this.__inoculationDate)).asHours());
    var minutes = Math.round(moment.duration(moment(new Date()).diff(this.__inoculationDate)).asMinutes())%60;
    this.value = `Culture time (${this.__id}): ${hours}h : ${minutes}min`;
  }
}

BatchAgeLabel.constructor();

export default BatchAgeLabel;